import React from "react";
import { Link } from "react-router-dom";
import {
  FaTwitter,
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import logo from "../images/logo.jpg";
import TawkMessenger from "./TawkMessenger";

const Footer = () => {
  return (
    <div className="mt-5" style={{ boxShadow: " #008080 0px 2px 8px 0px " }}>
      <div className="container py-5">
        <div className="row align-items-baseline">
          <div className="col-md-3">
            <Link to={"/"} className="navbar-brand">
              <img
                src={logo}
                width={180}
                height={80}
                className="object-fit-contain"
                alt=""
              />
            </Link>
            <p className="mt-4">
              Professional photo and video editing service for Professional
              photographers and Videographers
            </p>
          </div>
          <div className="col-md-3">
            <h5 className="fw-bold mb-3 text_maincolor">Services</h5>
            <p>
              <Link
                to={"/color-correction"}
                className="text-decoration-none text-dark fs-15"
              >
                Color Correction Services
              </Link>
            </p>{" "}
            <p>
              <Link
                to={"/retouching"}
                className="text-decoration-none text-dark fs-15"
              >
                Retouching Services
              </Link>
            </p>{" "}
            <p>
              <Link
                to={"/real-estate"}
                className="text-decoration-none text-dark fs-15"
              >
                Real Estate Services
              </Link>
            </p>
            <p>
              <Link
                to={"/album-editing"}
                className="text-decoration-none text-dark fs-15"
              >
                Album Editing Services
              </Link>
            </p>{" "}
            <p>
              <Link
                to={"/video-editing"}
                className="text-decoration-none text-dark fs-15"
              >
                Video Editing Services
              </Link>
            </p>{" "}
          </div>{" "}
          <div className="col-md-3">
            <h5 className="fw-bold mb-3 text_maincolor">Company</h5>
            <p>
              <Link
                to={"/privacy-policy"}
                className="text-decoration-none text-dark fs-15"
              >
                Privacy Policy
              </Link>
            </p>{" "}
            <p>
              <Link
                to={"/faqs"}
                className="text-decoration-none text-dark fs-15"
              >
                FAQs
              </Link>
            </p>{" "}
            <p>
              <Link
                to={"/why-us"}
                className="text-decoration-none text-dark fs-15"
              >
                Why Us
              </Link>
            </p>
          </div>{" "}
          <div className="col-md-3">
            <h5 className="fw-bold mb-3 text_maincolor">Contact</h5>
            <p>
              <Link
                to={"/testimonial"}
                className="text-decoration-none text-dark fs-15"
              >
                Testimonials
              </Link>
            </p>{" "}
            <p>
              <Link
                to={"/contact-us"}
                className="text-decoration-none text-dark fs-15"
              >
                Contact Us
              </Link>
            </p>
            <div className="d-flex align-items-center gap-3">
              <div className="bg_social">
                <a
                  href="https://www.facebook.com/profile.php?id=61577946193214"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF size={20} className="text-white" />
                </a>
              </div>
              <div className="bg_social">
                <a
                  href="https://www.instagram.com/captureedits.official/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram size={20} className="text-white" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <TawkMessenger />
      </div>
    </div>
  );
};

export default Footer;
